import type { BusinessProfile, Review } from './domain';

export const demoProfile: BusinessProfile = {
  businessName: 'Northstar Dental Studio',
  industry: 'Dental clinic',
  location: 'Madrid - Chamberí',
  brandVoice: 'professional',
  monthlyReviews: 42,
  averageTicket: 180,
  laborCostPerHour: 28,
  plan: 'starter'
};

export const demoReviews: Review[] = [
  {
    id: 'g-1001',
    source: 'Google',
    location: 'Madrid - Chamberí',
    reviewerName: 'Elena García',
    rating: 5,
    comment: 'Very kind team and the appointment started on time. The doctor explained every step clearly.',
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 2).toISOString(),
    status: 'new'
  },
  {
    id: 'g-1002',
    source: 'Google',
    location: 'Madrid - Chamberí',
    reviewerName: 'Carlos Ruiz',
    rating: 2,
    comment: 'I waited 50 minutes and nobody explained the delay. The service felt rushed and expensive.',
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 10).toISOString(),
    status: 'new'
  },
  {
    id: 'tp-3001',
    source: 'Trustpilot',
    location: 'Online booking',
    reviewerName: 'Marta López',
    rating: 1,
    comment: 'I was charged twice and still have no refund. This is unacceptable and I will file a complaint if nobody answers.',
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 29).toISOString(),
    status: 'new'
  },
  {
    id: 'fb-2100',
    source: 'Facebook',
    location: 'Madrid - Chamberí',
    reviewerName: 'Nadia M.',
    rating: 4,
    comment: 'Good cleaning and friendly staff. The reception area was a little crowded but the visit went well.',
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 36).toISOString(),
    status: 'new'
  },
  {
    id: 'manual-01',
    source: 'Manual',
    location: 'Imported CSV sample',
    reviewerName: 'Private customer',
    rating: 1,
    comment: 'Unsafe experience. My phone is +34 600 111 222 and nobody called me back after the incident.',
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 4).toISOString(),
    status: 'new'
  }
];

export const marketSignals = [
  'Owners can already respond manually for free in Google Business Profile, so the paid wedge is speed, delegation, risk triage and proof of response coverage.',
  'API integrations must be permissioned: the product defaults to import/demo/manual review queues and keeps publish actions under explicit human approval.',
  'The MVP avoids fabricated interactions: every draft is editable, reviewable and positioned as a suggested response, not an automated public post.'
];

export const pricingPlans = [
  {
    id: 'starter',
    name: 'Starter',
    price: 29,
    subtitle: '1 location, up to 75 reviews/month',
    cta: 'Start test checkout',
    features: ['Daily review inbox', 'Risk and urgency tags', 'Editable response drafts', 'Weekly ROI snapshot']
  },
  {
    id: 'growth',
    name: 'Growth',
    price: 79,
    subtitle: '3 locations, up to 300 reviews/month',
    cta: 'Start test checkout',
    features: ['Approval workflow', 'Team analytics', 'CSV export', 'High-risk alerts']
  },
  {
    id: 'agency',
    name: 'Agency',
    price: 199,
    subtitle: '15 locations, client-ready reporting',
    cta: 'Contact sales',
    features: ['Multi-client queues', 'White-label reports', 'SLA views', 'Priority API onboarding']
  }
];
